import { render, staticRenderFns } from "./Manage-availability.vue?vue&type=template&id=5b8b6c45&lang=html"
import script from "./Manage-availability.vue?vue&type=script&lang=js"
export * from "./Manage-availability.vue?vue&type=script&lang=js"
import style0 from "./Manage-availability.vue?vue&type=style&index=0&id=5b8b6c45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports